import sticky from './_sticky';

export function stickySidebar() {
  const spacingEl = document.querySelector('.sticky-margin');
  let spacing = 0;
  if(spacingEl) spacing = spacingEl.clientHeight

  const stickyNav = document.querySelector('.sticky-nav');
  if(stickyNav) {
    new sticky(stickyNav, {
      topSpacing: 0,
      bottomSpacing: spacing*2,
      containerSelector: '.sticky-nav-container',
      minWidth: 1023
    });
  }

  const stickyChat = document.querySelector('.sticky-chat');
  if(stickyChat) {
    new sticky(stickyChat, {
      topSpacing: 0,
      bottomSpacing: 0,
      containerSelector: '.sticky-chat-container',
      minWidth: 1023
    });
  }

  // const stickyProduct = document.querySelector('.sticky-product');
  // if(stickyProduct) {
  //   new sticky(stickyProduct, {
  //     topSpacing: spacing,
  //     bottomSpacing: 0,
  //     containerSelector: '.sticky-product-container',
  //     minWidth: 1023
  //   });
  // }
}